import React from 'react';
import { Price } from '../Price';

interface InfoPricesProps {
  containerClassName?: string;
  priceClassName?: string;
  labelPrice?: string;
  price?: number;
  labelScheduling?: string;
  scheduling?: string;
}

export const InfoPrices = ({
  containerClassName,
  priceClassName,
  labelPrice,
  price,
  labelScheduling,
  scheduling,
}: InfoPricesProps) => {
  return (
    <div className={containerClassName}>
      <Price text={labelPrice} price={price} className={priceClassName} />
      <p>{labelScheduling}</p>
      <p>
        <b>{scheduling}</b>
      </p>
    </div>
  );
};
